import { render, staticRenderFns } from "./05.2-ExtraInfoNotFound.vue?vue&type=template&id=56f957e4&scoped=true&"
import script from "./05.2-ExtraInfoNotFound.vue?vue&type=script&lang=js&"
export * from "./05.2-ExtraInfoNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f957e4",
  null
  
)

/* custom blocks */
import block0 from "./05.2-ExtraInfoNotFound.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports